import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';

import MixTable from './MixTable';
import CloneMixModal from './CloneMixModal';
import './Mix.css';
import ProductTable from '../Products/ProductTable';
import PageWrap from '../../components/PageWrap/PageWrap';
import ProductForm from '../Products/ProductForm';
import MixForm from './MixForm';
import MixDesignForm from './MixDesignForm';
import MixDesignTable from './MixDesignTable';
import { ActionEnum } from '../../constants/ActionEum';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import AdjustedMixTable from './AdjustedMixTable';
import AdjustedMixForm from './AdjustedMixForm';
import { withTranslation } from 'react-i18next';
import { showConfirmModal } from '../../modules/modals/confirmService';
import SlumpTableList from '../SlumpTable/SlumpTableList';
import SlumpTableForm from '../SlumpTable/SlumpTableForm';
import ManualAddTable from './ManualAdd/ManualAddTable';
import ManualAddForm from './ManualAdd/ManualAddForm';

const MixComponentsList = {
  ManualAddForm: 'ManualAddForm',
  ProductForm: 'ProductForm',
  AdjustedMixForm: 'AdjustedMixForm',
  MixForm: 'MixForm',
  MixDesignForm: 'MixDesignForm',
  MixDesignTable: 'MixDesignTable',
  SlumpTableForm: 'SlumpTableForm',
};

class Mix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCloneMixModalVisible: false,
      isProductFormVisible: false,
      isMixFormVisible: false,
      isMixDesignFormVisible: false,
      isMixDesignTableVisible: false,
      isAdjustedMixFormVisible: false,
      isSlumpTableFormVisible: false,
      isManualAddFormVisible: false,
      activeTab: 1,
      action: null,
    };
  }

  componentDidMount() {
    const { materialStore, mixStore, devicesStore } = this.props;

    if (!mixStore.allMixes.length || !mixStore.mixDesigns.length) {
      mixStore.load();
    }

    if (!materialStore.unit.length) {
      materialStore.loadTypes();
    }

    if (!materialStore.materials.length) {
      materialStore.loadMaterials();
    }

    if (!devicesStore.devices.length) {
      devicesStore.loadDevices();
    }
  }

  onDelete = () => {
    const { checkedIDs, checkedSize } = this.props.mixStore;

    if (!checkedSize) {
      return;
    }

    return showConfirmModal({
      title: `Are you sure you want to delete ${checkedSize} mix designs?`,
      okLabel: 'Yes',
      cancelLabel: 'No',
      enableEscape: false,
    })
      .then(() => {
        checkedIDs.forEach(id => {
          this.props.mixStore.deleteMix(id);
        });
      })
      .catch(() => {});
  };

  show = modal => () => {
    this.setState({ [`is${modal}Visible`]: true });
  };

  hide = modal => () => {
    this.setState({ [`is${modal}Visible`]: false });
  };

  onAddExtra = () => {
    this.show(MixComponentsList.ProductForm)();
    this.props.mixStore.editExtra();
  };

  onAddMix = () => {
    this.setState({ action: ActionEnum.ADD });
    this.props.mixStore.selectMix();
    this.show(MixComponentsList.MixForm)();
    this.show(MixComponentsList.MixDesignForm)();
    this.hide(MixComponentsList.MixDesignTable)();
  };

  onAddAdjustedMix = () => {
    this.props.mixStore.selectAdjustedProduct();
    this.show(MixComponentsList.AdjustedMixForm)();
  };

  onEditAdjustedMix = () => {
    this.show(MixComponentsList.AdjustedMixForm)();
  };

  onDeleteAdjustedMix = () => {
    this.hide(MixComponentsList.AdjustedMixForm)();
  };

  onAddManualAdd = () => {
    this.props.manualAddStore.selectManualAdd();
    this.show(MixComponentsList.ManualAddForm)();
  };

  onEditManualAdd = () => {
    this.show(MixComponentsList.ManualAddForm)();
  };

  onDeleteManualAdd = () => {
    this.hide(MixComponentsList.ManualAddForm)();
  };

  onAddSlumpTable = () => {
    this.props.slumpTableStore.setSlumpTableId(null);
    this.show(MixComponentsList.SlumpTableForm)();
  };

  onDeleteSlumpTable = () => {
    this.hide(MixComponentsList.SlumpTableForm)();
  };

  onEditMix = () => {
    this.setState({ action: ActionEnum.EDIT });
    this.show(MixComponentsList.MixForm)();
    this.show(MixComponentsList.MixDesignForm)();
    this.hide(MixComponentsList.MixDesignTable)();
  };

  onEditSlumpTable = () => {
    this.setState({ action: ActionEnum.EDIT });
    this.show(MixComponentsList.SlumpTableForm)();
    this.hide(MixComponentsList.MixForm)();
    this.hide(MixComponentsList.MixDesignForm)();
    this.hide(MixComponentsList.MixDesignTable)();
  };

  onPreviewMix = () => {
    this.setState({ action: ActionEnum.PREVIEW });
    this.show(MixComponentsList.MixForm)();
    this.hide(MixComponentsList.MixDesignForm)();
    this.show(MixComponentsList.MixDesignTable)();
  };

  onDeleteMix = () => {
    this.setState({ action: null });
    this.hide(MixComponentsList.MixForm)();
    this.hide(MixComponentsList.MixDesignForm)();
    this.hide(MixComponentsList.MixDesignTable)();
  };

  onCloseMixForm = () => {
    this.setState({ action: null });
    this.hide(MixComponentsList.MixForm)();
    this.hide(MixComponentsList.MixDesignForm)();
    this.hide(MixComponentsList.MixDesignTable)();
  };

  onClone = id => {
    this.show('CloneMixModal')();
  };

  onTabSelect = tab => {
    this.setState({ activeTab: tab, action: null });
  };

  render() {
    const { mixStore, connectionStore, t } = this.props;
    const { checkedSize } = mixStore;

    return (
      <PageWrap page={t('nav.Mix')}>
        <Row>
          <Col lg={7} sm={12}>
            <Portlet>
              <PortletTitle>
                <PortletCaption subject={t('Mixes & Extra Products')}/>
              </PortletTitle>
              <PortletBody>

                <Tabs defaultActiveKey={this.state.activeTab} id="mix" onSelect={this.onTabSelect}>
                  <Tab eventKey={1} title={t('Mixes')}>
                    <div className="mix-tab">
                      {!!checkedSize && (
                        <Row>
                          <Col sm={12} className="mix-button-container">
                            <a onClick={this.onDelete}
                              title="Remove selected"
                              className="btn btn-sm btn-default btn-action">
                              <i className="fa fa-trash"/>
                            </a>
                            <a onClick={mixStore.print}
                              title="Print selected"
                              className="btn btn-sm btn-default btn-action">
                              <i className="fa fa-print"/>
                            </a>
                          </Col>
                        </Row>
                      )}

                      {!connectionStore.isOnline && (
                        <a className="btn btn-sm btn-default btn-action pull-right"
                          title="Add mix"
                          onClick={this.onAddMix}>
                          <i className="fa fa-plus"/>
                        </a>
                      )}

                      <MixTable onEdit={this.onEditMix}
                        onDelete={this.onDeleteMix}
                        onPreview={this.onPreviewMix}
                        onClone={this.onClone}
                      />

                    </div>
                  </Tab>
                  <Tab eventKey={2} title={t('Extra Products')}>
                    <div className="extra-products">
                      {!connectionStore.isOnline && (
                        <a className="btn btn-sm btn-default btn-action pull-right"
                          title="Add extra product"
                          onClick={this.onAddExtra}>
                          <i className="fa fa-plus"/>
                        </a>
                      )}
                      {!!mixStore.extra.length && !connectionStore.isOnline && (
                        <div>
                          <ProductTable editable={true} onEdit={this.show(MixComponentsList.ProductForm)}/>
                        </div>
                      )}
                      <ProductTable onEdit={this.show(MixComponentsList.ProductForm)}/>
                    </div>
                  </Tab>
                  <Tab eventKey={3} title={t('Adjusted Mixes')}>
                    <div className="adjusted-mix-tab">
                      <a className="btn btn-sm btn-default btn-action pull-right"
                        title="Add adjusted mix"
                        onClick={this.onAddAdjustedMix}>
                        <i className="fa fa-plus"/>
                      </a>
                      <AdjustedMixTable
                        onEdit={this.onEditAdjustedMix}
                        onDelete={this.onDeleteAdjustedMix}
                      />
                    </div>
                  </Tab>
                  <Tab eventKey={4} title={t('Slump Tables')}>
                    <div className="adjusted-mix-tab">
                      <a className="btn btn-sm btn-default btn-action pull-right"
                        title="Add slump table"
                        onClick={this.onAddSlumpTable}>
                        <i className="fa fa-plus"/>
                      </a>
                      <SlumpTableList
                        onEdit={this.onEditSlumpTable}
                        onDelete={this.onDeleteSlumpTable}
                      />
                    </div>
                  </Tab>
                  <Tab eventKey={5} title={t('Manual Add')}>
                    <div className="adjusted-mix-tab">
                      <a className="btn btn-sm btn-default btn-action pull-right"
                        title="Add Manual"
                        onClick={this.onAddManualAdd}>
                        <i className="fa fa-plus"/>
                      </a>
                      <ManualAddTable
                        onEdit={this.onEditManualAdd}
                        onDelete={this.onDeleteManualAdd}
                      />
                    </div>
                  </Tab>
                </Tabs>

              </PortletBody>
            </Portlet>
          </Col>

          {this.state.activeTab === 1 && (
            <Col md={5} sm={12}>
              {this.state.isMixFormVisible &&
                  <MixForm onCancel={this.onCloseMixForm}/>
              }
              {this.state.isMixDesignFormVisible && mixStore.selectedId &&
                  <MixDesignForm onCancel={this.hide(MixComponentsList.MixDesignForm)}/>
              }
              {this.state.isMixDesignTableVisible && mixStore.selectedId && (
                <Portlet>
                  <PortletTitle>
                    <PortletCaption>{t('Mix Design')}</PortletCaption>
                  </PortletTitle>
                  <PortletBody>
                    <MixDesignTable mixId={mixStore.selectedId}/>
                  </PortletBody>
                </Portlet>
              )}
            </Col>
          )}
          {this.state.activeTab === 2 && this.state.isProductFormVisible && (
            <div>
              <Col md={5} sm={12}>
                <Portlet>
                  <PortletTitle>
                    <PortletCaption>Extra product #{mixStore.selectedExtraId}</PortletCaption>
                  </PortletTitle>
                  <PortletBody>
                    <ProductForm onCancel={this.hide(MixComponentsList.ProductForm)} />
                  </PortletBody>
                </Portlet>
              </Col>
            </div>
          )}
          {this.state.activeTab === 3 && (
            <Col md={5} sm={12}>
              {this.state.isAdjustedMixFormVisible &&
                    <AdjustedMixForm onCancel={this.hide(MixComponentsList.AdjustedMixForm)}/>
              }
            </Col>
          )}
          {this.state.activeTab === 4 && (
            <Col md={5} sm={12}>
              {this.state.isSlumpTableFormVisible &&
                    <SlumpTableForm onCancel={this.hide(MixComponentsList.SlumpTableForm)}/>
              }
            </Col>
          )}

          {this.state.activeTab === 5 && (
            <Col md={5} sm={12}>
              {this.state.isManualAddFormVisible &&
                <ManualAddForm onCancel={this.hide(MixComponentsList.ManualAddForm)}/>
              }
            </Col>
          )}
        </Row>

        <CloneMixModal
          show={this.state.isCloneMixModalVisible}
          onHide={this.hide('CloneMixModal')}
        />
      </PageWrap>
    );
  }
}

export default withTranslation()(inject('mixStore', 'materialStore', 'scheduleStore', 'connectionStore', 'devicesStore', 'slumpTableStore', 'manualAddStore')(observer(Mix)));
